import React from 'react';
import { Tag, Popconfirm, message, Tooltip } from 'antd';
import { EditOutlined, CopyOutlined, DeleteOutlined } from '@ant-design/icons';

export const getRegionGroupColumns = (
  handleEdit,
  onDeleteRegionGroup,
  handleCopy,
  currentuser,
  selectedOrg
) => [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (name, row) => {
      return name;
    },
  },
  {
    title: 'Regions',
    dataIndex: 'regions',
    key: 'regions',
    width: '60%',
    render: (regions) =>
      regions.map((region, index) => {
        return (
          <Tag color="blue" key={index}>
            {region}
          </Tag>
        );
      }),
  },
  {
    title: 'Preset List',
    dataIndex: 'isPresetList',
    key: 'isPresetList',
    width: '10%',
    sorter: (a, b) => (a.isPresetList ? 1 : -1) - (b.isPresetList ? 1 : -1),
    render: (isPresetList, isPresetRow) => {
      return (
        <Tooltip title={isPresetList ? 'This is a preset group' : 'This is a custom group'}>
          <span>{isPresetList ? 'Yes' : 'No'}</span>
        </Tooltip>
      );
    },
  },
  {
    title: '',
    key: 'edit',
    width: '5%',
    render: (_, region) => {
      const isDisabled = currentuser.role.org.name !== selectedOrg.name;

      return (
        <Tooltip title={isDisabled ? 'Cannot edit this group' : 'Edit Region Group'}>
          <span
            style={{
              marginRight: 8,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <EditOutlined
              onClick={() => !isDisabled && handleEdit(region)}
              style={{
                color: isDisabled ? '#ccc' : undefined,
                pointerEvents: isDisabled ? 'none' : 'auto',
              }}
            />
          </span>
        </Tooltip>
      );
    },
  },
  // console.log(currentuser.role.org.name, "current org");
  // console.log(selectedOrg.name, "selectedOrg");
  // disabled={currentuser.role.org.name === selectedOrg.name}
  {
    title: '',
    key: 'copy',
    width: '5%',
    render: (_, row) => {
      return (
        <Tooltip title="Duplicate Region Group">
          <CopyOutlined
            onClick={() => {
              handleCopy(row);
            }}
            style={{ marginRight: 8, cursor: 'pointer' }}
          />
        </Tooltip>
      );
    },
  },
  {
    title: '',
    key: 'delete',
    width: '5%',
    render: (_, location) => (
      <Popconfirm
        title="Are you sure you want to delete this Region Group?"
        onConfirm={() => onDeleteRegionGroup(location.id)}
        onCancel={() => message.warning('cancelled')}
        okText="Yes"
        cancelText="No"
      >
        <Tooltip title="Delete Region Group">
          <DeleteOutlined style={{ cursor: 'pointer' }} />
        </Tooltip>
      </Popconfirm>
    ),
  },
];
